import React from "react";
import Stat from "../../components/Stat";

function ClientsKpi() {
  return (
    <div className="container-fluid">
      <h1 className="mb-3" style={{ fontWeight: 400, fontSize: 18 }}>
        Les donnees des differentes CLIENTS
      </h1>
      <Stat label={"Clients"} />
    </div>
  );
}

export default ClientsKpi;
